module.exports = __webpack_public_path__ + "static/media/1014793.c1881eb2.jpg";